import { getNewBoxChatToken } from '../../services/twilioServices';

export const getAndUpdateNewRoomChatToken = async (
  userId,
  chatSID,
  participantName,
  boxConversations
) => {
  const token = await getNewBoxChatToken(userId, chatSID, participantName);
  try {
    // const globalConversations = await Client.create(token);
    // setGlobalConversations(globalConversations);
    // const res = await boxConversations.updateToken(token);
    // console.log('updated token for box chat', res);
    boxConversations.updateToken(token);
  } catch (error) {
    console.log(error, 'error');
  }
};
